<template>
    <div class="content__body">
        <div class="profile-info profile-info-notifications">
            <UILoader v-if="isSettingsLoading" class="listable" />

            <div v-else class="profile-info__body profile-info__body-notifications">
                <div
                    v-for="setting in settings"
                    class="profile-info__body-row"
                >
                    <div class="profile-info__body-name">{{ setting.name }}</div>

                    <div class="profile-info__body-value">{{ setting.conditions }}</div>

                    <div class="profile-info__body-toggle">
                        <UIToggle
                            v-model="setting.active"
                            @update:model-value="onChangeNotificationActivity(setting)"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { onMounted, ref } from 'vue';

    import { UserNotificationSetting } from '@/types/user.type.ts';

    import useUserRepository from '@/repositories/user/useUserRepository.ts';

    import UILoader from '@/components/ui/UILoader/UILoader.vue';
    import UIToggle from '@/components/ui/UIToggle/UIToggle.vue';

    const { isSettingsLoading, getUserNotificationSettings, updateUserNotificationSettings } = useUserRepository();

    const settings = ref<UserNotificationSetting[]>([]);

    function onChangeNotificationActivity(setting: UserNotificationSetting): void {
        updateUserNotificationSettings({
            symbolic_code: setting.symbolic_code,
            active: setting.active ? 1 : 0,
        });
    }

    function fetchUserNotificationSettings(): void {
        getUserNotificationSettings().then((fetchedSettings: UserNotificationSetting[]) => {
            settings.value = fetchedSettings;
        });
    }

    onMounted(() => {
        fetchUserNotificationSettings();
    });
</script>

<style scoped lang="scss">
    @use 'NotificationsTab' as *;
</style>
